
import MarkdownIt from 'markdown-it'
import removeMd from 'remove-markdown'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { CreateElement } from 'vue'

@Component
export default class Markdown extends Vue {
  @Prop({ default: false })
  readonly plain!: boolean

  render(h: CreateElement) {
    if (this.plain) {
      const innerText = removeMd(this.$slots!.default![0].text!.trim())
      return h(
        'article',
        {
          domProps: { innerText }
        },
        []
      )
    } else {
      const innerHTML = new MarkdownIt({ html: false }).render(
        this.$slots!.default![0].text!.trim()
      )
      return h(
        'article',
        {
          domProps: { innerHTML }
        },
        []
      )
    }
  }
}
